/*
 * Tencent is pleased to support the open source community by making
 * 蓝鲸智云PaaS平台 (BlueKing PaaS) available.
 *
 * Copyright (C) 2021 THL A29 Limited, a Tencent company.  All rights reserved.
 *
 * 蓝鲸智云PaaS平台 (BlueKing PaaS) is licensed under the MIT License.
 *
 * License for 蓝鲸智云PaaS平台 (BlueKing PaaS):
 *
 * ---------------------------------------------------
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
 * documentation files (the "Software"), to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and
 * to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of
 * the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
 * THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF
 * CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */
import { h } from 'vue';

import { commonSVGProps } from '../common';
export const CheckCircleFillIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-check-circle-icon': true,
    },
  },
  [
    // 图标路径
    h('path', {
      d: 'M512 85.333333c235.52 0 426.666667 191.146667 426.666667 426.666667s-191.146667 426.666667-426.666667 426.666667S85.333333 747.52 85.333333 512 276.48 85.333333 512 85.333333m-42.666667 618.666667l298.666667-298.666667-60.16-60.16L469.333333 583.253333l-131.84-131.413333L277.333333 512l192 192z',
    }),
  ],
);

export const TimeIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-time-icon': true,
    },
  },
  [
    // 外圈路径
    h('path', {
      d: 'M512 70.4a441.6 441.6 0 1 0 0 883.2 441.6 441.6 0 0 0 0-883.2z m0 64a377.6 377.6 0 1 1 0 755.2 377.6 377.6 0 0 1 0-755.2z',
    }),
    // 时针与分针路径
    h('path', {
      d: 'M544 480V256a32 32 0 1 0-64 0v230.4c0 31.7952 25.8048 57.6 57.6 57.6H768a32 32 0 1 0 0-64h-224z',
    }),
  ],
);

export const CloseCircleFillIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-close-circle-icon': true,
    },
  },
  [
    // 图标路径
    h('path', {
      d: 'M85.333333 512C85.333333 276.352 276.352 85.333333 512 85.333333s426.666667 191.018667 426.666667 426.666667-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512z m269.653334-96.661333l96.810666 96.810666-96.810666 96.810667c-16.661333 16.661333-16.384 43.84 0.277333 60.501333l0.512 0.512c16.64 16.64 42.88 16 59.541333-0.682666l96.810667-96.810667 96.832 96.810667c16.64 16.682667 42.88 17.344 59.541333 0.682666l0.512-0.512c16.64-16.64 16.938667-43.84 0.277334-60.501333l-96.810667-96.810667 96.810667-96.810666c16.661333-16.661333 16.384-43.861333-0.277334-60.522667l-0.490666-0.490667c-16.682667-16.661333-42.901333-16-59.562667 0.661334l-96.832 96.810666-96.810667-96.810666c-16.64-16.64-42.88-17.322667-59.541333-0.661334a109.44 109.44 0 0 1-0.512 0.490667c-16.64 16.661333-16.938667 43.861333-0.277333 60.522667z',
    }),
  ],
);

// 已撤销图标
export const RevokedIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-revoked-icon': true,
    },
  },
  [
    // 图标路径
    h('path', {
      d: 'M512 64a448.056889 448.056889 0 1 1-0.056889 896.056889A448.056889 448.056889 0 0 1 512 64zM448 256l-128 96.256L448.284444 448 448 384l128.113778 0.113778a128 128 0 0 1 0 255.886222h-224.142222v64h224.028444a192 192 0 1 0 0-384h-128V256z',
    }),
  ],
);
// 帮助文档图标：圆形问号，用于用户回答问题面板标题
export const HelpDocIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-help-doc-icon': true,
    },
    viewBox: '0 0 16 16',
  },
  [
    h('path', {
      d: 'M8 1C11.8656 1 15 4.13438 15 8C15 11.8656 11.8656 15 8 15C7.07969 15 6.2 14.8234 5.39531 14.5H2C1.72344 14.5 1.5 14.2766 1.5 14V10.6047C1.17812 9.79844 1 8.92031 1 8C1 4.13438 4.13438 1 8 1ZM8.54825 10.1578H7.37878V11.3687H8.54825V10.1578ZM8.07669 4.62969C7.4876 4.62969 6.98847 4.81875 6.5793 5.19844C6.17013 5.57812 5.91911 6.1375 5.8248 6.87656L7.07407 7.06875C7.14082 6.25156 7.44262 5.84219 7.98092 5.84219C8.18406 5.84219 8.35817 5.9125 8.50037 6.05156C8.64401 6.19062 8.71511 6.38125 8.71511 6.62344C8.71511 6.82031 8.67593 6.98438 8.60048 7.11719C8.52358 7.25 8.38864 7.39375 8.19421 7.54688C7.82277 7.84219 7.59497 8.06719 7.50791 8.22188C7.42085 8.37656 7.37732 8.75312 7.37732 9.34844V9.53438L8.5555 9.53281C8.5555 9.21562 8.58597 8.99687 8.64836 8.87969C8.71075 8.7625 8.88922 8.59844 9.18377 8.38906C9.86136 7.9125 10.2009 7.31875 10.2009 6.60781C10.2009 6.03437 9.99776 5.5625 9.59004 5.18906C9.18232 4.81563 8.67883 4.62969 8.07669 4.62969Z',
    }),
  ],
);

export const InfoIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-info-icon': true,
    },
  },
  [
    // 外圆环路径
    h('path', {
      d: 'M512 64C264 64 64 264 64 512s200 448 448 448 448-200 448-448S760 64 512 64zM512 896C299.2 896 128 724.8 128 512S299.2 128 512 128s384 171.2 384 384S724.8 896 512 896z',
    }),
    // "i" 的下半部分主体
    h('path', {
      d: 'M494.4 403.2c-28.8 6.4-56 20.8-76.8 41.6-24 22.4 1.6 44.8 16 27.2 9.6-12.8 24-22.4 40-28.8 11.2-1.6 17.6 1.6 19.2 9.6 1.6 14.4 0 27.2-4.8 41.6-4.8 19.2-14.4 51.2-25.6 94.4-22.4 76.8-33.6 124.8-30.4 140.8 3.2 17.6 12.8 32 28.8 41.6 17.6 8 38.4 9.6 57.6 4.8 30.4-6.4 57.6-22.4 80-44.8 25.6-25.6-3.2-43.2-17.6-28.8-9.6 12.8-24 22.4-40 25.6-14.4 3.2-22.4-3.2-25.6-16-1.6-14.4 1.6-28.8 6.4-41.6 40-136 57.6-212.8 52.8-232-3.2-14.4-12.8-27.2-25.6-33.6C532.8 398.4 512 398.4 494.4 403.2z',
    }),
    // "i" 的上半部分圆点
    h('path', { d: 'M608 304A48 48 0 0 1 560 352 48 48 0 0 1 512 304 48 48 0 0 1 608 304z' }),
  ],
);

export const EnterIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-enter-icon': true,
    },
  },
  [
    h('path', {
      d: 'M853.312 213.312a42.88 42.88 0 0 1 39.424 26.24c2.176 5.184 3.264 10.752 3.264 16.384v170.688a213.376 213.376 0 0 1-213.312 213.312H273.6l97.92 97.856a42.688 42.688 0 1 1-60.352 60.288L140.48 627.392a42.688 42.688 0 0 1 0-60.288l170.688-170.688a42.688 42.688 0 0 1 60.352 60.352L273.664 554.624h409.024a128 128 0 0 0 128-128V255.936a42.624 42.624 0 0 1 42.624-42.624z',
    }),
  ],
);

export const SkipIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-skip-icon': true,
    },
    viewBox: '0 0 16 16',
  },
  [
    h('path', {
      d: 'M8.90283 2.5C9.0329 2.5 9.15984 2.54778 9.25781 2.63477L14.8184 7.57764C15.0396 7.77544 15.0618 8.11664 14.8677 8.3418L14.8203 8.38965L9.25928 13.3481C9.16135 13.4351 9.03479 13.4829 8.90479 13.4829L8.92139 13.5L8.8877 13.4966L8.90479 13.4829C8.60922 13.4829 8.36922 13.2408 8.36914 12.9424V10.5151L8.35059 10.5166C7.88774 10.5575 7.16279 10.6464 6.34521 10.8408C5.51593 11.0387 4.75076 11.3046 4.07178 11.6304C3.27109 12.0159 2.54628 12.5246 1.97363 13.1011C1.95343 13.1215 1.93477 13.1419 1.91455 13.1641L1.91309 13.1655C1.78136 13.3071 1.63093 13.4692 1.43506 13.4692L1.38623 13.4673C1.27492 13.4573 1.17834 13.4125 1.10889 13.3379C1.0616 13.2871 1.00802 13.2025 1.00098 13.0713V13.0122C1.00605 12.9217 1.01435 12.8483 1.02344 12.7881L1.0498 12.6436L1.05127 12.6367C1.05461 12.6215 1.05672 12.6081 1.06006 12.5962V12.5928C1.09553 12.3744 1.24727 11.5792 1.72363 10.4961C2.02937 9.80192 2.40431 9.15706 2.8418 8.58057C3.38909 7.86249 4.03116 7.24513 4.75244 6.75049C4.90953 6.63152 6.29681 5.61619 8.1709 5.24268L8.354 5.2085L8.36768 5.20703V3.04053C8.36777 2.74214 8.60732 2.50005 8.90283 2.5ZM9.36768 6.08887L8.50342 6.19775C6.78304 6.50227 5.47434 7.45858 5.35645 7.54785L5.3374 7.56201L5.31787 7.5752C4.68887 8.00657 4.12342 8.54907 3.63721 9.18701C3.25072 9.69661 2.91527 10.2725 2.63916 10.8994C2.55608 11.0883 2.48518 11.2675 2.42285 11.4341C2.80507 11.1708 3.21334 10.934 3.63818 10.7295L3.63916 10.729C4.38977 10.3689 5.2233 10.0805 6.11328 9.86816H6.11426C6.99177 9.65947 7.76654 9.56436 8.26221 9.52051L8.27783 9.51904L9.36914 9.41895V11.9106L13.7715 7.98486L9.36768 4.07031V6.08887Z',
    }),
  ],
);
